<template>
    <div class="news">
        <div class="line"></div>
        <p class="title a " v-if=" $i18n.locale === 'zh-CN'">君安资讯</p>
        <p class="title b">news media</p>
        <div class="main">
            <swiper class="swiper" :options="swiperOption2"  ref="mySwipers" v-if="newsList.length>1">
            <swiper-slide class="item" v-for="(item,index) in newsList" :key="index">
                <router-link :to="{path: 'newsInfo',query:{id:item.ID}}" target="_blank">
                    <div class="left">
                        <p>{{item.TITLE}}</p>
                        <p>{{item.SHOWTIME}}</p>
                    </div>
                    <img :src="`http://junankg.com/upload/${item.SMALLPIC}`" alt="">
                    <div class="b">

                    </div>
                    <span></span>
                </router-link>
            </swiper-slide>
        </swiper>
            <swiper class="swiper2" :options="swiperOption3"  ref="mySwipers2" v-if="newsList.length>1">
                <swiper-slide class="item" v-for="(item,index) in newsList" :key="index">
                    <router-link :to="{path: 'newsInfo',query:{id:item.ID}}" target="_blank">
                        <div class="left">
                            <p>{{item.TITLE}}</p>
                            <p>{{item.SHOWTIME}}</p>
                        </div>
                        <img :src="`http://junankg.com/upload/${item.SMALLPIC}`" alt="">
                        <div class="b">

                        </div>
                        <span></span>
                    </router-link>
                </swiper-slide>
            </swiper>
            <div class="btn prev ">
                <btn-Component style="padding-top: 0"></btn-Component>
            </div>
            <div class="btn next ">
                <btn-Component style="padding-top: 0"></btn-Component>
            </div>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import btnComponent from '../components/btn2'
    import { getNewsUrl} from '../util/lang'
    export default {
        name: "xw",
        data(){
            return{
                swiperOption2:{
                    notNextTick: true,
                    slidesPerView: 4,
                    speed:1000,
                    loop: true,
                    autoplay:false,
                    setWrapperSize :true,
                    autoHeight :true,
                    navigation: {
                        prevEl: '.news .btn.prev',
                        nextEl: '.news .btn.next',
                    }
                },
                swiperOption3:{
                    notNextTick: true,
                    slidesPerView: 1,
                    speed:1000,
                    loop: true,
                    autoplay:false,
                    setWrapperSize :true,
                    autoHeight :true,
                    navigation: {
                        prevEl: '.news .btn.prev',
                        nextEl: '.news .btn.next',
                    }
                },
                newsList:[]
            }
        },
        components:{swiperSlide,swiper,btnComponent},
        mounted() {
            if( this.$i18n.locale === 'en'){
                this.getNews('33')
            }else{
                this.getNews('26')
            }
        },
        methods:{
            getNews(id){
                const url = `${getNewsUrl(this.$i18n.locale,id,100,1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.SHOWTIME=item.SHOWTIME.slice(0,11)
                        if(item.ISCOMMEND==='1'){
                            this.newsList.push(item)
                        }
                    })
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                        this.$refs.mySwipers2.swiper.init()
                    },100)

                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .news{
        width:100%;
        margin: 60px auto;
        position: relative;
        padding-bottom: 60px;
        .line{
            width:20%;
            height:1px;
            background-color: #828282;
            margin-left: 15%;
        }
        .title{
            width:35%;
            margin-left: 35%;
            text-align: left;
            padding-top: 15px;
        }
        .a{
            font-size: 25px;
            font-weight: bold;
            color:#04356F;
        }
        .b{
            font-size: 35px;
            font-weight: bold;
            text-transform: uppercase;
            color:#444546;
            padding-top: 5px;
        }
        .main{
            width:100%;
            display: flex;
            flex-direction: row;
            padding: 80px 0;
            .swiper{
                width:100%;
                padding-bottom: 60px;
                height:400px;
            }
            .swiper2{
                width:100%;
                padding-bottom: 60px;
                height:400px;
                display: none;
            }
            .item{
                overflow: hidden;
                margin-left: 20px;
                height:400px;
                position: relative;
                cursor: pointer;
                .left{
                    position: absolute;
                    top:10%;
                    left:5%;
                    width:90%;
                    color:white;
                    font-size: 14px;
                    line-height: 30px;
                    z-index: 100;
                    p:nth-child(1){
                        font-size: 18px;
                        font-weight: bolder;
                        text-shadow: 2px 2px 6px rgba(0,0,0,.8);
                    }
                }
                img{
                    width:100%;
                    object-fit: cover;
                    height:100%;
                }
                .b{
                    width:100%;
                    height:100%;
                    display: inline-block;
                    left:0;
                    top:0;
                    background-color: rgba(0,0,0,.5);
                    position: absolute;
                    z-index: 10;
                    opacity: 1;
                    transition: all 600ms;
                }
                span{
                    width:50px;
                    height:50px;
                    position: absolute;
                    top:45%;
                    left:45%;
                    z-index: 100;
                    opacity: 0;
                    transition: all 600ms;
                }
                span::before{
                    position: absolute;
                    left:20%;
                    content:'';
                    top:40%;
                    background-color: white;
                    height:1px;
                    width:60%;
                    display: inline-block;
                    transform: rotate(-90deg);
                    transition: all 600ms;
                }
                span::after{
                    position: absolute;
                    left:20%;
                    content:'';
                    top:40%;
                    background-color: white;
                    height:1px;
                    width:60%;
                    display: inline-block;
                    transition: all 600ms;
                }
            }
            .item:hover{
                .b{
                    background-color: rgba(0, 104, 183, .9);
                }
                span{
                    opacity: 1;
                }
                span::before{
                    transform: rotate(0);
                }
                span::after{
                    transform: rotate(90deg);
                }
            }
            .prev{
                width:60px;
                height:60px;
                position: absolute;
                left:5%;
                bottom:10%;
                border-radius: 50%;
                transform: rotate(180deg);
                z-index: 1000;
            }
            .next{
                width:60px;
                height:60px;
                border-radius: 50%;
                position: absolute;
                left:15%;
                bottom:10%;
                z-index: 1000;
            }
        }
        .prev:focus{
            outline: none;
        }
        .next:focus{
            outline: none;
        }
        @media screen and (max-width:1440px){
            .main{
                .item{
                    height:300px;
                }
            }
        }
        @media screen and (max-width:1366px){
            padding-bottom: 0;
            margin-bottom: 0;
            .main{
                .swiper{
                    display: none;
                }
                .swiper2{
                    display: block;
                    .item{
                        margin-left: 0;
                    }
                }
                .prev{
                    bottom:15%;
                }
                .next{
                    bottom:15%;
                    left:40%;
                }
            }
            .title{
                width:50%;
            }
                .a{
                    font-size: 22px;
            }
            .b{
                font-size: 25px;
            }
        }
    }
</style>
